export default __webpack_public_path__ + "static/media/FluidStorageIndustrial.64.8f76a6ac.png";